import React, {Component} from 'react';
import CommunityPage from './CommunityPage';
import './CommunityNoticesPage.css';
import communityActions from './community.actions';
import {
	getMembersByUserUUID,
	getSessionUserMembership,
	getProfileUniqueName,
	getParamsUniqueName
} from './community.selectors';
import CommunitySidePane from './CommunitySidePane';
import actions from './notices.actions';
import {connect} from 'react-redux';
import {DocumentTitle, EmptyMessage, Spinner, PrimaryButton} from '../widgets';
import {uiActions} from '../chrome';
import CommunityNotice from './CommunityNotice';
import confirmActions from '../widgets/confirmation.actions';
import userHasBaseDetails from '../user/userHasBaseDetails';

export class CommunityNoticesPage extends CommunityPage {
	constructor(props) {
		super(props);

		const paramUniqueName = getParamsUniqueName(this.props);
		if (
			paramUniqueName &&
			(!this.props.community || getProfileUniqueName(this.props) !== paramUniqueName)
		) {
			props.retrieveCommunity(paramUniqueName);
		} else {
			this.props.community && this.props.community.noticesEnabled;
			props.conditionallyRetrieveNotices();
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.community && nextProps.community.profile) {
			this.props.conditionallyRetrieveNotices();
		}
	}

	render() {
		const {
			sessionProvider,
			notices,
			onAddComment,
			addingNotice,
			editContacts,
			joinCommunity,
			confirmRemoval,
			editNotice
		} = this.props;

		const membersByUUID = getMembersByUserUUID(this.props);
		const sessionUserMembership = getSessionUserMembership(this.props);

		if (!membersByUUID || !this.props.community || !this.props.community.profile) {
			return (
				<DocumentTitle title="B2Me">
					<main className="CommunityNoticesPage">
						<Spinner />
					</main>
				</DocumentTitle>
			);
		}

		return (
			<DocumentTitle title={`${this.props.community.name} - B2Me`}>
				<main className="CommunityNoticesPage">
					{joinCommunity && userHasBaseDetails(sessionProvider) && !sessionUserMembership && (
						<PrimaryButton onClick={joinCommunity} icon="person_add">
							Join this community
						</PrimaryButton>
					)}

					<CommunitySidePane
						community={this.props.community}
						sessionProvider={sessionProvider}
						editContacts={editContacts}
						addingNotice={() => addingNotice(sessionProvider.user.uuid)}
						showAbout={false}
						joinCommunity={joinCommunity}
					/>
					<section className="CommunityNoticesPage-noticeboard">
						{notices && notices.items && notices.items.length ? (
							notices.items.map(notice => (
								<CommunityNotice
									key={notice.uuid}
									{...notice}
									membersByUUID={membersByUUID}
									sessionProvider={sessionProvider}
									sessionUserMembership={sessionUserMembership}
									onAddComment={onAddComment}
									removeNotice={confirmRemoval}
									editNotice={editNotice}
								/>
							))
						) : (
							<EmptyMessage>There are no notices for this community.</EmptyMessage>
						)}
					</section>
				</main>
			</DocumentTitle>
		);
	}
}

const ConnectedCommunityNoticesPage = connect(
	({community, session, notices}) => ({
		community,
		sessionProvider: session && session.current,
		notices
	}),
	dispatch => ({
		joinCommunity: uniqueName => dispatch(communityActions.joinCommunity()),
		retrieveCommunity: uniqueName => dispatch(communityActions.retrieveCommunity(uniqueName)),
		conditionallyRetrieveNotices: uuid => dispatch(actions.conditionallyRetrieveNotices()),
		onAddComment: (uuid, userUuid, newComment) =>
			dispatch(actions.persistComment({uuid, userUuid, newComment})),
		editContacts: () => {
			dispatch(communityActions.communityEditContacts());
			dispatch(uiActions.uiModal('community-edit-contacts'));
		},
		addingNotice: userUuid => {
			dispatch(actions.noticesAdding(userUuid));
			dispatch(uiActions.uiModal('community-add-notice'));
		},
		confirmRemoval: uuid =>
			dispatch(
				confirmActions.open({
					title: `Do you really want to remove this notice?`,
					message:
						'The notice content and all user comments will be permanently removed. Are you sure?',
					onConfirm: () => dispatch(actions.removeNotice(uuid))
				})
			),
		editNotice: uuid => {
			dispatch(actions.noticesEditing(uuid));
			dispatch(uiActions.uiModal('community-edit-notice'));
		}
	})
)(CommunityNoticesPage);

export default ConnectedCommunityNoticesPage;



// WEBPACK FOOTER //
// ./src/community/CommunityNoticesPage.js